/* Send Bids search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';
import Auth from '../auth/auth';

export interface ISearchFiltersSendBidsState {
    manager: string;
    regionId: any;
    statusId: any;
}

const auth = new Auth();

const initialState: ISearchFiltersSendBidsState = {
    manager:  '',
    regionId: -1,
    statusId: 1,
};

export function searchFiltersSendBidsReducer(state: ISearchFiltersSendBidsState = initialState, action: any): ISearchFiltersSendBidsState {
    switch (action.type) {
        case Actions.SEND_BIDS_FILTER_MANAGER:
            return _.merge({}, state, { manager: action.username });
        case Actions.SEND_BIDS_FILTER_STATUS:
            return _.merge({}, state, { statusId: action.statusId });
        case Actions.SEND_BIDS_FILTER_REGION:
            return _.merge({}, state, { regionId: action.regionId });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersSendBidsReducer.tsx